/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {ChangeDetectionStrategy, Component, Inject, OnInit, signal} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-copy-in-bulk-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {Uuid} from '../../components/util/uuid';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';
import {bulkApiErrorsFromResponse} from '../common/controller/bulk-action-errors';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-creative-copy-in-bulk-modal',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreativeCopyInBulkModalComponent implements OnInit {
  list: any;
  Creative: any;
  onComplete: (updatedCreatives?: any, bulkSelection?: any) => void;

  attach = 'LINE_ITEM';
  hasCreativeSet = false;
  noGoodMessage: string;
  adv: any;
  private readonly formState = signal<any>({}, {equal: () => false});
  get form(): any { return this.formState(); }
  set form(value: any) { this.formState.set(value); }
  lineItem: any;
  creativeSet: any;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any,
    private readonly localNetworkInfo: LocalNetworkInfo = new LocalNetworkInfo()
  ) {
  }

  ngOnInit(): void {
    this.hasCreativeSet = this.localNetworkInfo.getInfo('creativeSetCount') > 0;

    const advs = _.uniqBy(_.filter(_.map(this.list.bulkSelection, (val: any) => {
      return _.get(val, ['advertiser']);
    }), (f: any) => {
      return _.get(f, ['id']);
    }), 'id');

    if (advs.length > 1) {
      this.noGoodMessage = 'The creatives you selected belong to more than one advertiser. You cannot copy these creatives in bulk.';
    } else if (advs.length === 1) {
      this.adv = advs[0];
    } else if (Object.keys(this.list.bulkSelection).length === 0) {
      this.noGoodMessage = 'No creatives have been selected to copy.';
    }
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  copyInBulk(): void {
    this.form.apiErrors = [];
    this.form.bulkError = false;
    const copyPromises: any[] = [];
    _.forEach(this.list.bulkSelection, (creative: any) => {
      if (this.attach === 'LINE_ITEM') {
        copyPromises.push(firstValueFrom(this.Creative.copyCreative(creative, {lineItemId: this.lineItem?.id, creativeId: Uuid.generate()})));
      } else {
        copyPromises.push(firstValueFrom(this.Creative.copyCreative(creative, {creativeSetId: this.creativeSet?.id, creativeId: Uuid.generate()})));
      }
    });
    Promise.all(copyPromises).then((updatedCreatives: any) => {
      this.list.disabled = false;
      this.adnModalLoading.removeModalLoading();
      this.onComplete?.(updatedCreatives, this.list.bulkSelection);
      this.bsModalRef.hide();
    }, (response: any) => {
      this.adnModalLoading.removeModalLoading();
      this.list.disabled = false;
      this.form.apiErrors = bulkApiErrorsFromResponse(response);
      this.form.bulkError = true;
      this.form = this.form;
    });
  }
}
